<mat-toolbar>
  <span>Configure Lookup For - {{ field?.FieldId }}</span>
</mat-toolbar>
<div class="container">
  <mat-card>
    <mat-card-title>Source</mat-card-title>
    <mat-card-content>
      <mat-radio-group [(ngModel)]="sourceType" (change)="onSourceTypeChange()">
        <mat-radio-button value="feed">Feed</mat-radio-button>
        <mat-radio-button value="udq">UDQ</mat-radio-button>
      </mat-radio-group>
      <br />
      @if (sourceType === SourceType.Feed) {
        <mat-select class="select-medium push-top" placeholder="Select Feed" title="Select Feed" required [(ngModel)]="sourceFeed" (selectionChange)="onSourceFeedChange()">
          @for (feed of feeds; track feed) {
            <mat-option [value]="feed">{{ feed.Name }}</mat-option>
          }
        </mat-select>
      }
      @if (sourceType === SourceType.Udq) {
        <mat-form-field class="example-full-width push-top" required>
          <mat-label>UDQ ID</mat-label>
          <input matInput maxlength="36" [(ngModel)]="sourceUdqId" (input)="onSourceUdqIdChange()">
        </mat-form-field>
      }
      @if (this.lookupFieldsLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </mat-card-content>
  </mat-card>

  @if (this.lookupFields) {
    <process-type-option
      [processType]="processType"
      (processingTypeChanged)="setProcessingType($event)">
    </process-type-option>
  }

  @if (this.lookupFields) {
    <mat-card>
      <mat-card-title>Primary Field</mat-card-title>
      <mat-card-content>
        <mat-select class="select-medium" placeholder="Primary Field" title="Primary Field" required [(ngModel)]="primaryField" (selectionChange)="onPrimaryFieldChange()">
          @for (field of this.lookupFields; track field) {
            <mat-option [value]="field">{{ field.name }}</mat-option>
          }
        </mat-select>
      </mat-card-content>
    </mat-card>
  }

  @if (this.lookupFields) {
    <mat-card>
      <mat-card-title>Match Type</mat-card-title>
      <mat-card-content>
        <mat-radio-group [(ngModel)]="matchType">
          <mat-radio-button value="fuzzy">Like</mat-radio-button>
          <mat-radio-button value="exact">Exact</mat-radio-button>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
  }

  @if (isServerSideProcessing) {
    <server-side-lookup-options
      [(failValidationOnFailedLookup)]="failValidationOnFailedLookup"
      [(publishAnywayOnFailedLookup)]="publishAnywayOnFailedLookup"
      [(allowMappingAfterFirstSave)]="allowMappingAfterFirstSave">
    </server-side-lookup-options>
  }

  @if (this.lookupFields && isClientSideProcessing) {
    <mat-card>
      <mat-card-title>Preview Fields</mat-card-title>
      <mat-card-content>
        @for (previewField of this.previewFields; track previewField; let previewFieldIndex = $index) {
          <div layout="column">
            <div>
              <mat-form-field>
                <input matInput placeholder="Field Label (must match form)" title="Field Label (must match form)" [(ngModel)]="previewField.label" />
              </mat-form-field>
              <mat-select class="select-medium" placeholder="Feed field" title="Feed field" [(ngModel)]="previewField.lookupField">
                @for (field of this.lookupFields; track field) {
                  <mat-option [value]="field">{{ field.name }}</mat-option>
                }
              </mat-select>
              <button mat-icon-button type="button" (click)="removePreviewField(previewFieldIndex)" color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </mat-card-content>
      <mat-card-actions class="align-right">
        <button mat-raised-button type="button" (click)="addNewPreviewField()" color="primary">Add New Preview Field </button>
      </mat-card-actions>
    </mat-card>
  }

  @if (this.lookupFields && !isClientSideProcessing) {
    <mat-card>
      <mat-card-title>Default Metadata</mat-card-title>
      <mat-card-content>
        The field to be used for the lookup if the user does not supply one
      </mat-card-content>
      <mat-card-content>
        <mat-select class="select-medium" [(ngModel)]="defaultField">
          @for (enum of DefaultField | keyvalue; track enum) {
            <mat-option [value]="enum.value">{{ enum.key }}</mat-option>
          }
        </mat-select>
      </mat-card-content>
    </mat-card>
  }

  @if (this.lookupFields) {
    <autofill-field-mapping
      [autoFillDefinition]="this.field.AutoFillDefinition"
      [stepFields]="this.otherFields"
      [potentialMappingFields]="this.lookupFields"
      (mappingsChange)="autoFillMappingsChanged($event)">
    </autofill-field-mapping>
  }

  @if (this.lookupFields && isClientSideProcessing) {
    <mat-card>
      <mat-card-title>Enabled When</mat-card-title>
      <mat-card-content>
        <mat-select matInput class="select-medium" id="enabledWhenField" placeholder="Field Name" title="Field Name" [(ngModel)]="enabledWhenField">
          @for (field of this.otherFields; track field) {
            <mat-option [value]="field">{{ field.FieldId }}</mat-option>
          }
        </mat-select>
        <mat-form-field>
          <input matInput placeholder="Field Value" title="Field Value" [(ngModel)]="enabledWhenValue" />
        </mat-form-field>
        <button mat-icon-button type="button" (click)="clearEnabledWhen()" color="warn">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  }


  @if (this.lookupFields && isClientSideProcessing) {
    <mat-card>
      <mat-card-title>Offline Settings</mat-card-title>
      <mat-card-content>
        <mat-checkbox [(ngModel)]="isEnabledOffline">Lookup enabled offline</mat-checkbox>
      </mat-card-content>
    </mat-card>
  }

  <mat-card>
    <mat-card-actions align="end">
      <button mat-raised-button type="button" color="primary" (click)="goBack()">Close</button>
      <button mat-raised-button type="submit" color="accent" [disabled]="!valid" (click)="onSave()">Save</button>
    </mat-card-actions>
  </mat-card>
</div>